import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { comics, reviews } from '@/mocks/comics';

const coverImages: Record<string, string> = {
  'secret-class': 'https://readdy.ai/api/search-image?query=Secret%20Class%20Korean%20manga%20cover%20art%20illustration%20with%20soft%20romantic%20atmosphere%20warm%20lighting%20elegant%20composition&width=440&height=587&seq=comic-cover-01&orientation=portrait',
  'demon-king': 'https://readdy.ai/api/search-image?query=Demon%20King%20Returns%20Korean%20manga%20cover%20dramatic%20fantasy%20scene%20dark%20atmosphere%20powerful%20character%20illustration&width=440&height=587&seq=comic-cover-02&orientation=portrait',
  'love-signal': 'https://readdy.ai/api/search-image?query=Love%20Signal%20Korean%20romance%20manga%20cover%20sweet%20couple%20illustration%20pastel%20colors%20dreamy%20atmosphere&width=440&height=587&seq=comic-cover-03&orientation=portrait',
  'dark-detective': 'https://readdy.ai/api/search-image?query=Dark%20Detective%20Korean%20manga%20mystery%20noir%20cover%20atmospheric%20dark%20city%20street%20detective%20silhouette%20illustration&width=440&height=587&seq=comic-cover-04&orientation=portrait',
  'action-hero': 'https://readdy.ai/api/search-image?query=Fighting%20King%20Korean%20action%20manga%20cover%20dynamic%20martial%20arts%20scene%20powerful%20character%20intense%20battle%20illustration&width=440&height=587&seq=comic-cover-05&orientation=portrait',
  'star-romance': 'https://readdy.ai/api/search-image?query=Star%20Romance%20Korean%20manga%20cover%20beautiful%20couple%20under%20starry%20night%20sky%20romantic%20dreamy%20atmosphere%20soft%20colors&width=440&height=587&seq=comic-cover-06&orientation=portrait',
  'fantasy-world': 'https://readdy.ai/api/search-image?query=Isekai%20Reincarnation%20Korean%20fantasy%20manga%20cover%20magical%20world%20portal%20adventure%20colorful%20vibrant%20illustration&width=440&height=587&seq=comic-cover-07&orientation=portrait',
  'mystery-house': 'https://readdy.ai/api/search-image?query=Mystery%20House%20Korean%20horror%20suspense%20manga%20cover%20eerie%20mansion%20dark%20atmosphere%20chilling%20thriller%20illustration&width=440&height=587&seq=comic-cover-08&orientation=portrait',
  'school-fight': 'https://readdy.ai/api/search-image?query=School%20Fight%20Korean%20action%20manga%20cover%20students%20battle%20scene%20dynamic%20schoolyard%20setting%20energetic%20illustration&width=440&height=587&seq=comic-cover-09&orientation=portrait',
  'office-romance': 'https://readdy.ai/api/search-image?query=Office%20Romance%20Korean%20manga%20cover%20elegant%20workplace%20setting%20professional%20couple%20romantic%20tension%20sophisticated%20illustration&width=440&height=587&seq=comic-cover-10&orientation=portrait',
  'magic-academy': 'https://readdy.ai/api/search-image?query=Magic%20Academy%20Korean%20fantasy%20manga%20cover%20grand%20magical%20school%20students%20casting%20spells%20enchanting%20atmosphere%20illustration&width=440&height=587&seq=comic-cover-11&orientation=portrait',
  'crime-city': 'https://readdy.ai/api/search-image?query=Crime%20City%20Korean%20noir%20suspense%20manga%20cover%20dark%20urban%20landscape%20gritty%20crime%20scene%20intense%20thriller%20illustration&width=440&height=587&seq=comic-cover-12&orientation=portrait',
};

export default function ComicDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const comic = comics.find((c) => c.slug === slug);

  if (!comic) {
    return (
      <>
        <Navbar />
        <div className="pt-20 flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-800 mb-4">漫画未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 whitespace-nowrap">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const related = comics
    .filter((c) => c.category === comic.category && c.id !== comic.id)
    .slice(0, 4);

  const pageUrl = `http://zhidavip.com/comic/${comic.slug}`;

  return (
    <>
      <Navbar />
      <Breadcrumb />
      <main>
        <section className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 bg-background-100 relative overflow-hidden min-h-[400px] lg:min-h-[520px]">
            <img
              src={coverImages[comic.id] || ''}
              alt={comic.title}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute top-8 left-8">
              <span className="text-xs text-foreground-600 font-medium tracking-wider whitespace-nowrap bg-background-50/80 px-3 py-1 rounded-full">
                {comic.status}
              </span>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <h1 className="font-heading text-4xl md:text-5xl font-black text-foreground-950 leading-tight">
                {comic.title}
              </h1>
              <p className="text-foreground-600 text-sm mt-2">作者：{comic.author}</p>
            </div>
          </div>

          <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-8 md:px-16 py-12 lg:py-0">
            <div className="max-w-md text-center">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-2">
                {comic.title}
              </h2>
              <div className="flex items-center justify-center gap-3 mb-4 flex-wrap">
                <span className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                  comic.status === '连载中' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {comic.status}
                </span>
                <span className="text-sm text-foreground-500">
                  评分 <strong className="text-primary-600">{comic.rating}</strong>
                </span>
                <span className="text-sm text-foreground-500">
                  <strong className="text-foreground-700">{(comic.views / 10000).toFixed(0)}万</strong> 阅读
                </span>
              </div>
              <p className="text-foreground-500 leading-relaxed mb-8 text-sm md:text-base">
                {comic.description}
              </p>
              <Link
                to={`/comic/${comic.slug}/chapter/${comic.chapters[0].id}`}
                className="inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                开始阅读
                <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center" />
              </Link>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-6">章节列表</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {comic.chapters.map((ch, i) => (
                <Link
                  key={ch.id}
                  to={`/comic/${comic.slug}/chapter/${ch.id}`}
                  className="flex items-center justify-between p-4 rounded-xl bg-background-100 hover:bg-background-200/80 transition-colors cursor-pointer group"
                >
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-bold">
                      {comic.chapters.length - i}
                    </span>
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                      {ch.title}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span>{ch.date}</span>
                    <i className="ri-arrow-right-s-line text-sm w-4 h-4 flex items-center justify-center" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 mb-3">
                <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-chat-quote-line text-accent-600 text-sm w-4 h-4 flex items-center justify-center" />
                </span>
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">读者评价</span>
              </div>
              <h2 className="font-heading text-3xl font-bold text-foreground-950">真实阅读反馈</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-6xl mx-auto">
              {reviews.slice(0, 5).map((review, i) => (
                <div key={review.id} className={`bg-background-50 rounded-2xl p-6 ${
                  i === 2 ? 'md:row-span-2 bg-secondary-100/60' : ''
                }`}>
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-10 h-10 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-800">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                  <i className="ri-double-quotes-l text-accent-400 text-xl block mb-3" />
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {related.length > 0 && (
          <section className="bg-foreground-950 py-14 md:py-18">
            <div className="w-full px-4 md:px-6">
              <div className="flex items-center gap-3 mb-10">
                <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-700 text-foreground-300 text-xs font-medium whitespace-nowrap">
                  同类热门
                </span>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
                  猜你喜欢
                </h2>
              </div>

              <div className="flex gap-5 overflow-x-auto pb-4" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                {related.map((item) => (
                  <Link
                    key={item.id}
                    to={`/comic/${item.slug}`}
                    className="flex-shrink-0 w-[200px] md:w-[220px] group cursor-pointer"
                  >
                    <div className="aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
                      <img
                        src={coverImages[item.id] || ''}
                        alt={`${item.title} - 韩国漫画`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                        loading="lazy"
                      />
                    </div>
                    <div className="px-1">
                      <h3 className="font-heading text-base font-bold text-white truncate mb-1">{item.title}</h3>
                      <p className="text-xs text-foreground-500">{item.chapters[0]?.title}</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://zhidavip.com/" },
            { "@type": "ListItem", "position": 2, "name": comic.categoryName, "item": `http://zhidavip.com/category/${comic.category}` },
            { "@type": "ListItem", "position": 3, "name": comic.title, "item": pageUrl }
          ]
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": comic.title,
          "description": comic.description,
          "author": {
            "@type": "Person",
            "name": comic.author
          },
          "image": coverImages[comic.id] || '',
          "url": pageUrl,
          "genre": comic.categoryName,
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": comic.rating,
            "bestRating": "10",
            "reviewCount": comic.views.toString()
          }
        })
      }} />
    </>
  );
}